import React from "react";
import {
  Button,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { formatNumber, formatPercent } from "../networkReportFormatters";
import {
  networkOrganizationReportPath,
  networkOrganizationWorkbookPath,
} from "../networkReportPaths";
import ReportStatusBadge from "./ReportStatusBadge";
import { FactorRows } from "./NetworkOrganizationQuiltCard";

const FactorList = ({ factors = [], emptyText = "N/A" }) => {
  if (!factors.length) return <Text color="gray.500">{emptyText}</Text>;

  return <FactorRows factors={factors} tone="strength" emptyText={emptyText} />;
};

const DevelopmentFactorList = ({ factors = [], emptyText = "N/A" }) => (
  <FactorRows factors={factors} tone="development" emptyText={emptyText} />
);

const OrganizationActions = ({ organization, networkId, size = "xs" }) => (
  <HStack spacing={2} flexWrap="wrap">
    {organization.reportAvailable && organization.organizationSurveyId ? (
      <Button
        as={RouterLink}
        to={networkOrganizationReportPath(networkId, organization.organizationSurveyId)}
        size={size}
        variant="outline"
        colorScheme="blue"
      >
        School report
      </Button>
    ) : null}
    {organization.workbookAvailable && organization.organizationId ? (
      <Button
        as={RouterLink}
        to={networkOrganizationWorkbookPath(networkId, organization.organizationId)}
        size={size}
        variant="outline"
        colorScheme="purple"
      >
        Workbook
      </Button>
    ) : null}
  </HStack>
);

const OrganizationReportTable = ({ organizations = [], networkId }) => (
  <TableContainer>
    <Table>
      <Thead>
        <Tr>
          <Th>School</Th>
          <Th>Strengths</Th>
          <Th>Development Areas</Th>
          <Th>Survey</Th>
          <Th>Status</Th>
          <Th>Completion</Th>
          <Th>Overall Stability</Th>
          <Th>Actions</Th>
        </Tr>
      </Thead>
      <Tbody>
        {organizations.map((organization) => {
          const hasMeasuredData = !["not_started", "no_survey"].includes(organization.status);

          return (
            <Tr key={organization.id}>
              <Td fontWeight="semibold">{organization.organizationName}</Td>
              <Td><FactorList factors={hasMeasuredData ? organization.strengths : []} /></Td>
              <Td><DevelopmentFactorList factors={hasMeasuredData ? organization.developmentAreas : []} /></Td>
              <Td>{organization.surveyName}</Td>
              <Td><ReportStatusBadge status={organization.status} /></Td>
              <Td>{formatPercent(organization.completionRate)}</Td>
              <Td>{hasMeasuredData ? formatNumber(organization.overallStabilityIndex) : "N/A"}</Td>
              <Td><OrganizationActions organization={organization} networkId={networkId} /></Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  </TableContainer>
);

export { DevelopmentFactorList, FactorList, OrganizationActions };
export default OrganizationReportTable;
